import { gql } from "@apollo/client";

export const submitAsset = gql`
    mutation SubmitAsset($input: SubmitAssetRequest!) {
        submitAsset(input: $input) {
            assetId
        }
    }
`;
